<template>
  <div class="middle-top">
    <div class="top">
      <div class="tag">
        <div
          class="item"
          @click="change_url(item.url, item.alias)"
          :class="{ active: item.alias === is_active }"
          v-for="(item, index) in list"
          :key="index"
        >
          {{ item.name }}
        </div>
        <!-- <div class="item" @click="change_url('', 'monitor')" :class="{ active: is_active === 'monitor' }">
          位置监测
        </div> -->
      </div>
    </div>
    <div class="monitor" v-show="is_active === 'monitor'">
      <cMonitor :options="mapData" ref="c_monitor" @warning="show_dialog" />
    </div>
    <div v-show="is_active !== 'monitor'" class="video">
      <video id="my-player" class="video-js" controls webkit-playsinline playsinline x5-playsinline></video>
    </div>
    <div class="warn-dialog" v-if="show">
      <div class="title warning-modal-header">
        {{ current.name }}
      </div>
      <div class="icon">
        <img src="../../assets/dongti/swimer.png" />
      </div>
      <div class="name">{{ current.desc }}</div>
      <div class="btn-area">
        <a-button @click="cancel(current)" v-if="current.img_type == 1" type="primary">取消警报</a-button>
        <a-button @click="show = false" type="danger" style="margin-left: 8px">关闭</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css'

import videojs from 'video.js'
import 'videojs-contrib-hls'

import storage from 'store'
import { SID } from '@store/mutation-types.js'

import cMonitor from './cMonitor'
import dragDialog from '@components/drag-dialog'

let timer

export default {
  components: { cMonitor },
  directives: { dragDialog },
  data() {
    return {
      video: null,
      list: [],
      is_active: null,
      current: {},
      show: false,
			
			mapData: {},
    }
  },
  mounted() {
		// this.get_pools()
		
    this.init()

    // this.get_warning()
    // timer = setInterval(() => {
    //   this.get_warning()
    // }, 10000)

    setTimeout(() => {
      // this.video.on('play')
      // console.log(111);
      // this.video = null

      // this.init()
    }, 10000)
  },
  beforeDestroy() {
    clearInterval(timer)

    this.video.dispose()
  },
  methods: {
		get_pools() {
		  this.$http({
		    url: `bkapi/stadium/pools`,
		    // baseURL: '/bkapi',
		    // method: 'get',
		    params: {
		      sid: storage.get(SID),
		    },
		  }).then((r) => {
				// console.log('---1', r)
				this.mapData = r[0]
		    // this.pool_list = r.data.list
		  })
		},
		
    get_warning() {
      this.$http({
        url: `stadium/drawning-alarm`,
        method: 'get',
        params: {
          project: 'mbkj',
          mapid: '4',
          sid: storage.get(SID),
        },
      }).then((r) => {
        this.$refs.c_monitor.warning(r.data)
        if (r.data.length) {
          this.show = false
          this.$nextTick(() => {
            this.current = {
              name: '泳客行为报警',
              desc: r.message,
            }
            this.$set(this, 'show', true)
          })
        }
      })
    },
    cancel(row) {
      this.$http({
        url: `stadium/cancel-drawning-alarm`,
        method: 'post',
        data: {
          tag: row.tag,
          project: 'mbkj',
          mapid: '4',
        },
      }).then((r) => {
        const i = this.list.findIndex((item) => {
          return item.tag === row.tag
        })
        this.list.splice(i, 1)
        this.show = false
      })
    },
    show_dialog(data) {
      this.current = data
      this.show = true
    },
    change_url(url, name) {
      this.is_active = name
      if (url) {
        this.video.pause()
        this.$nextTick(() => {
          this.video.ready(() => {
            this.video.src({
              src: url,
              type: 'application/x-mpegURL',
            })
            this.$nextTick(() => {
              this.video.play()
            })
          })
        })
      }
    },
    init() {
			console.log('-----', process.env.NODE_ENV)
      this.$http({
        url: 'api/streams',
        params: {
          host: process.env.NODE_ENV == 'development' ? 'http://192.168.0.170:8080' : window.location.origin,
        },
      }).then((r) => {
        this.list = r.data
        this.video = videojs('my-player', {
          // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
          autoplay: false, // 如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          poster: 'poster.jpg', // 你的封面地址
          width: document.documentElement.clientWidth,
          notSupportedMessage: '此视频暂无法播放，请稍后再试',
        })

        this.video.ready(() => {
          this.video.src({
            src: this.list[0].url,
            type: 'application/x-mpegURL',
          })
        })
        this.is_active = this.list[0].alias
      })
    },
  },
}
</script>

<style lang="less" scoped>
.middle-top {
  .warn-dialog {
    position: absolute;
    top: 0%;
    left: 0%;
    width: 240px;
    z-index: 9999;
    background: url(../../assets/dongti/warn-bg.png) no-repeat center center/100% 100%;
    padding: 15px;
    .title {
      position: relative;
    }
    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 80%;
      }
    }
    .name {
      font-weight: bold;
      font-size: 16px;
      text-align: center;
      margin: 12px 0;
    }
    .btn-area {
      margin-top: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.middle-top {
  color: #fff;
  /deep/ .video-js .vjs-big-play-button {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .monitor {
    margin-top: 130px;
    padding: 0 50px;
  }
  .top {
    display: flex;
    justify-content: flex-end;
    position: relative;
    z-index: 999;
    .tag {
      display: flex;
      align-items: center;
      padding: 5px 8px;
      background: #0a4066;
      border: 1px solid #08c3ee;
      position: absolute;
      top: 12px;
      right: 16px;
      .item {
        font-size: 14px;
        color: #fff;
        padding: 5px 12px;
        cursor: pointer;
        &.active {
          background: #08c3ee;
        }
      }
    }
  }
  .video {
    width: 100%;
    height: 400px;
    padding: 20px;
    margin-top: 40px;
    /deep/ .my-player-dimensions.vjs-fluid {
      padding-top: 523px;
    }
  }
}
</style>
